import { createFileRoute } from '@tanstack/react-router';

import { TelegramSettingsPage } from '@/features/telegram/pages/TelegramSettingsPage';

export const Route = createFileRoute('/_app/$wsSlug/settings/telegram')({
  component: TelegramSettingsPage,
});
